module.exports = __webpack_public_path__ + "media/assets/faria_products/OA_CRM-a0207173cf00bb32dbda9f1da8c8b94da5f42f66c74d90ea1b065f54b0116625.png";